import { onBeforeUnmount, watch, type WatchStopHandle } from 'vue'
import { useRoute } from 'vue-router'
import { useUserStore } from '@/authentication/user.store'
import { useContentProfileStore } from '@/contentprofile/contentprofile.store'
import { useVisibilityStore } from '@/visibility/visibility.store'
import { toolkitUrls } from '@/util/links.js'

const CONCLUSION_PATH = '/presentlevels/conclusion/'

// Every profile with AI features, effect-statement profiles included, uses the v2 wizard;
// only no-AI profiles stay on this one. aiFeatureVisibility reads true until the content
// profile loads, so the check waits for the user and then the profile before deciding.
export function useAiProfileRedirect() {
  const route = useRoute()
  const userStore = useUserStore()
  const contentProfileStore = useContentProfileStore()
  const visibilityStore = useVisibilityStore()

  let isUnmounted = false
  let stopWaitingForProfile: WatchStopHandle | undefined

  function isConclusionPage() {
    return route.path.includes(CONCLUSION_PATH)
  }

  function redirectAiProfiles() {
    if (visibilityStore.aiFeatureVisibility && !isConclusionPage()) {
      window.location.href = toolkitUrls.presentlevelsWizardV2
    }
  }

  function redirectOnceProfileLoads() {
    if (isUnmounted) {
      return
    }
    if (!contentProfileStore.fetchingActiveProfile) {
      redirectAiProfiles()
      return
    }
    stopWaitingForProfile = watch(
      () => contentProfileStore.fetchingActiveProfile,
      (isFetchingProfile) => {
        if (isFetchingProfile) {
          return
        }
        stopWaitingForProfile?.()
        redirectAiProfiles()
      }
    )
  }

  if (userStore.fetching) {
    userStore.pushOnetimeCallback(redirectOnceProfileLoads)
  } else {
    redirectOnceProfileLoads()
  }

  onBeforeUnmount(() => {
    isUnmounted = true
    stopWaitingForProfile?.()
  })
}
